import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

import { CommonService, HierarchyType } from '../common/common.service';
import { User, UserHierarchy } from '../user/user.model';
import { UserService } from '../user/user.service';

import { TranslationKeyMap } from './profile.i18n';

@Component({
    selector: 'cmps-profile-hierarchy',
    templateUrl: './hierarchy.profile.component.html',
})
export class HierarchyProfileComponent implements OnInit, OnDestroy {
    @Input()
    which: 'managers' | 'subordinates';

    @Input()
    user: User;

    i18n = TranslationKeyMap;
    header: string;
    private _translateSub: Subscription;
    hasPendingData: boolean;
    hierarchyTypeOpts: any[];

    constructor(
        private readonly _translateService: TranslateService,
        private readonly _commonService: CommonService,
        private readonly _userService: UserService,
    ) {}

    ngOnInit(): void {
        this._load();

        this._translateSub = this._translateService.onLangChange.subscribe(
            (event: LangChangeEvent) => this._load(),
        );
    }

    ngOnDestroy(): void {
        if (this._translateSub) {
            this._translateSub.unsubscribe();
        }
    }

    private _load(): void {
        this.header = this._translateService.instant(
            this.which === 'managers'
                ? TranslationKeyMap._48_MANAGER
                : TranslationKeyMap._659_SUBORDINATE,
        );

        this.hasPendingData = true;
        this.hierarchyTypeOpts = [];
        this._commonService
            .listHierarchyTypes()
            .pipe(
                map((hierarchyTypes: HierarchyType[]) => {
                    hierarchyTypes.forEach((value) =>
                        this.hierarchyTypeOpts.push({
                            label: value.label,
                            value: value.id,
                        }),
                    );
                }),
                concatMap(() =>
                    this._userService
                        .listHierarchy(this.which, this.user.id)
                        // eslint-disable-next-line no-return-assign
                        .pipe(
                            map(
                                (hierarchy: UserHierarchy[]) =>
                                    (this.user[this.which] = hierarchy),
                            ),
                        ),
                ),
            )
            .subscribe(
                () => null,
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }
}
